import React, { useState } from "react";
import { message } from "antd";
import DetailsCard from "./DetailsCard";
import InlineEditableNameCell from "./InlineEditableNameCell";
import useGoto from "../../../../hooks/useGoto";

const ExtensionDetails = ({
  extensionData,
  onAssignUser,
  onAssignDepartment,
  onAssignLocation,
  refetch,
  canAssignLocation,
}) => {
  const [editingName, setEditingName] = useState(false);
  const [currentName, setCurrentName] = useState(extensionData?.name);

  const { updateCallExtension, loading: updatingExtensionLoading } = useGoto({
    operation: "updateCallExtension",
    onCompleted: async data => {
      message.success(data?.updateCallExtension?.message);
      setEditingName(false);
      if (refetch) {
        await refetch();
      }
    },
    onError: err => {
      console.error("Error updating extension:", err);
    },
  });

  // Extension details object - using the same fields as the table
  const details = {
    Name: editingName ? (
      <InlineEditableNameCell
        value={currentName}
        record={extensionData}
        placeholder="Name"
        editing={editingName}
        loading={updatingExtensionLoading}
        onStartEdit={() => setEditingName(true)}
        onSave={async newName => {
          setCurrentName(newName);
          await updateCallExtension({
            variables: {
              extensionId: extensionData.id,
              name: newName,
            },
          });
        }}
        onCancel={() => {
          setEditingName(false);
        }}
      />
    ) : (
      currentName || "--"
    ),
    Extension: extensionData?.number || "--",
    "EAI user": extensionData?.user?.fullName || null,
    Department: extensionData?.departmentLevel || null,
    ...(canAssignLocation && { Location: extensionData?.originalLocation?.title || null }),
  };

  const handleEdit = fieldKey => {
    if (fieldKey === "EAI user") {
      if (onAssignUser) onAssignUser();
    } else if (fieldKey === "Department") {
      if (onAssignDepartment) onAssignDepartment();
    } else if (fieldKey === "Location") {
      if (onAssignLocation) onAssignLocation();
    } else if (fieldKey === "Name") {
      setEditingName(true);
    }
  };

  return (
    <div className="mb-4">
      {/* Extension details using DetailsCard */}
      <DetailsCard
        title="Details"
        details={details}
        editableFields={["Name", "EAI user", "Department", "Location"]}
        onEdit={handleEdit}
      />
    </div>
  );
};

export default ExtensionDetails;
